import { LOADING_MESSAGES } from "@booking/consts";
import { BOOKING } from "@booking/paths";
import clsx from "clsx";

import { usePortal } from "@/booking/hooks/usePortal";
import { ColorEnum } from "@/enums";
import { type CommonProps } from "@/types";

import styles from "./Loading.module.css";

const ref = "loading";

interface LoadingProps extends Pick<CommonProps, "className" | "iconColor"> {
  hideMessage?: boolean;
  inline?: boolean;
  message?: string;
  pageRef?: string;
  container?: string;
  inContainer?: boolean;
}

function useLoading(props: LoadingProps) {
  const className = clsx(
    styles[ref],
    props.hideMessage && styles["hide-message"],
    styles[props.iconColor || ColorEnum.GREEN],
    !props.inline && !props.inContainer && styles.fullscreen,
    props.inContainer && styles.inContainer,
    props.className,
  );
  const message = `${props.message || LOADING_MESSAGES[props.pageRef || BOOKING.ROOT]}`;

  return {
    className,
    message,
  };
}

function Loading(props: LoadingProps) {
  const { className, message } = useLoading(props);
  const Portal = usePortal(props.container);

  const content = (
    <div className={`${className} before:animate-spin`}>
      <span>{message}&hellip;</span>
    </div>
  );

  if (props.inline) {
    return content;
  }

  return <Portal>{content}</Portal>;
}

export default Loading;
export { Loading, type LoadingProps };
